import { Action } from 'redux'
import { PriceGridAction } from '../../reducers/price/actionNames'

export interface IPricesAccepted extends Action {
  selectedRooms?: number[]
  prices: any
}

const pricesAccepted = (prices, selectedRooms?): IPricesAccepted => {
  return {
    prices,
    selectedRooms,
    type: PriceGridAction.PricesAccepted,
  }
}

export default pricesAccepted
